// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list {
  background: #6d6d6d;
  --background: #6d6d6d;
}
ion-list ion-item {
  --background: #6d6d6d;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/nav/nav.component.scss"],"names":[],"mappings":"AACA;EACI,mBAAA;EACA,qBAAA;AAAJ;AACI;EACI,qBAAA;EACA,YAAA;AACR","sourcesContent":["\nion-list {\n    background: #6d6d6d;\n    --background: #6d6d6d;\n    ion-item{\n        --background: #6d6d6d;\n        color: white\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
